import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TrackedChangeReplaced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M9 2H8C6.34315 2 5 3.34315 5 5V11C5 12.6569 6.34315 14 8 14H9" stroke={color} />
        <path
          d="M8.97409 11.6728L9.74586 9.49984H12.848L13.6197 11.6728H14.5938L11.7765 4H10.8174L8 11.6728H8.97409ZM10.0381 8.67562L11.2669 5.21386H11.3269L12.5557 8.67562H10.0381Z"
          fill={color}
        />
        <path d="M1 2H2C3.65685 2 5 3.34315 5 5V11C5 12.6569 3.65685 14 2 14H1" stroke={color} />
      </svg>
    )
  },
)

export default TrackedChangeReplaced
